export type ChartConfig = {
    xDomain: [number, number];
    yDomain: [number, number];
    xTicks: number[];
};
  
export const chartConfigurations: Record<string, Record<string, ChartConfig>> = {
    
    NHANES: {
      // For All filter, the max value is maximum of above i.e. 118.67
      'All': {
        xDomain: [0, 120],
        yDomain: [0, 100],
        xTicks: [0, 2, 20, 40, 60, 80, 100, 120],
      },
      // For US Males, the max value of 100th percentile is 89.77
      'US Male': {
        xDomain: [0, 90],
        yDomain: [0, 100],
        xTicks: [0, 2, 20, 40, 60, 80, 100],
      },
      // For US Females, the max value of 100th percentile is 118.67
      'US Female': {
        xDomain: [0, 120],
        yDomain: [0, 100],
        xTicks: [0, 2, 20, 40, 60, 80, 100, 120],
      },
    },
};
